import { BetLimitContext } from '@/contexts/BetLimitContext';
import { ScreenContext } from '@/contexts/ScreenContext';
import { useUserAgent } from '@/hooks/useUserAgent';
import { ROUTE_MULTIBET } from '@/models/Route';
import { VoiceFile } from '@/models/Voice';
import { RootState } from '@/store/store';
import { useWindowSize } from '@react-hook/window-size/throttled';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getSettingSoundState } from '../setting/selector';
import { analyticSliceActions } from './slice';

export const useAnalytic = () => {
    const dispatch = useDispatch();
    const ua = useUserAgent();
    const size = useWindowSize();
    const { i18n } = useTranslation();
    const { selectedLimitRed } = useContext(BetLimitContext);
    const { Voice2 } = useSelector(getSettingSoundState);
    const analyticState = useSelector(
        (state: RootState) => state['app::analytic']
    );
    const { isLandscape } = useContext(ScreenContext);
    useEffect(() => {
        const info = {
            browser: ua.browser,
            device: ua.device,
            os: ua.os,
            engine: ua.engine,
        };
        dispatch(analyticSliceActions.updateUaInfo(info));
    }, [ua]);

    useEffect(() => {
        dispatch(analyticSliceActions.updateScreen());
    }, [size]);
    useEffect(() => {
        dispatch(analyticSliceActions.updateLocale(i18n.language));
    }, [i18n.language]);
    useEffect(() => {
        dispatch(analyticSliceActions.updateVoiceOver(VoiceFile[Voice2]));
    }, [Voice2]);
    useEffect(() => {
        let min = 0;
        let max = 0;
        if (selectedLimitRed !== undefined) {
            min = selectedLimitRed.MinBet;
            max = selectedLimitRed.LimitRed;
        }
        dispatch(
            analyticSliceActions.updateBetLimit({
                minBet: min,
                maxBet: max,
            })
        );
    }, [selectedLimitRed]);
    useEffect(() => {
        const isMultiBet = location.pathname === ROUTE_MULTIBET;
        dispatch(analyticSliceActions.updateIsMultiBet(isMultiBet));
    }, [location.pathname]);
    useEffect(() => {
        dispatch(analyticSliceActions.updateIsLandscape(isLandscape));
    }, [isLandscape]);
    useEffect(() => {
        console.log('analyticState', analyticState);
    }, [analyticState]);
};
